import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import _ from "lodash";
import { Search, Close } from "@mui/icons-material";
import { Button } from "@mui/material";
import { ProjectManagerDetailView } from "./components/detailsView";
import { CommonModal } from "src/components/modal";
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import { getByIdDepotPersonal } from "src/thunks/depotUsers";
import { getAllClientProject, getAllProjectManagers, } from "src/thunks/clientProjects";
import { AddProjectManagerForm } from "./components/addProjectManagerForm";
import { Loader } from "src/components/loader";
import { GetError } from "src/constant";

export const ProjectManagers = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const projectManagersList = useSelector((state) => state?.clientProjects?.projectManagersList);

  /** hooks useState ----------------------------------------------------- **/
  const [loader, setLoader] = useState(false);
  const [projectManagerShowData, setProjectManagerShowData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedRowIndex, setSelectedRowIndex] = useState("");
  const [isEditFlag, setIsEditFlag] = useState(false);
  const [showViewRecordButton, setShowViewRecordButton] = useState(false);
  const [isEditTextShown, setIsEditTextShown] = useState(false);

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    getProjectManager();
  }, []);

  useEffect(() => {
    setProjectManagerShowData([...projectManagersList]);
  }, [projectManagersList]);

  /** handler functions--------------------------------------------------- **/

  /** Function to filter the project manager list by first name or last name. */
  const handleSearchInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
    if (searchText === "") {
      setProjectManagerShowData(projectManagersList);
    } else {
      const newFilter = projectManagersList.filter((value) => {
        return (
          value.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
          value.lastName.toLowerCase().includes(searchText.toLowerCase())
        );
      });
      setProjectManagerShowData(newFilter);
    }
  };

  /** Function to retrieve all project managers data ---------------------------- **/
  const getProjectManager = async () => {
    setLoader(true);
    try {
      await dispatch(getAllProjectManagers()).unwrap();
      setLoader(false);
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
      setLoader(false);
    }
  };

  /** Function to retrieve all clients with projects data ------------------------ **/
  const getAllClientsData = async () => {
    try {
      await dispatch(getAllClientProject()).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const handleOpen = async () => {
    getAllClientsData();
    setOpen(!open);
  };

  /** Function execute when clear the entered search value ------------------- **/
  const handleClearSearchText = () => {
    handleSearchInputChange({ target: { value: "" } });
  };

  // Function execute when click on view record button and give the API call to fetch specific project manager by id
  const handleViewRecordButtonClick = async () => {
    setIsEditFlag(true);
    setLoader(true);
    try {
      let data = await dispatch(getByIdDepotPersonal(selectedRow.id));
      setLoader(false);
      setSelectedRow(data?.payload || selectedRow);
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
      setLoader(false);
    }
  };

  /** Function to navigate back ---------------------**/
  const handleBackButtonClick = () => {
    setIsEditFlag(false);
    setSelectedRow({});
    getProjectManager();
    setSelectedRow({});
    setShowViewRecordButton(false);
  };

  /** Function to retrieve grant app access flag ------------------------------ **/
  const showGrantAppAccessFlag = (item) => {
    return item?.projects?.some((project) => project.grantAppAccess === true)
      ? "Active"
      : "Inactive";
  };

  const handleRowClick = (item, index) => {
    setSelectedRow(item);
    setSelectedRowIndex(index);
    setShowViewRecordButton(!showViewRecordButton);
  };

  /** Function to retrieve client names -------------------- **/
  const showClientName = (data) => {
    const uniqueClientNames = _.union(_.map(data || "", (d) => d.clientName));
    const formattedClientNames = uniqueClientNames.join(", ");
    return formattedClientNames;
  };

  /** Function to handle image error -------------------- **/
  const imgError = (image) => {
    image.onerror = "";
    image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
    return true;
  }

  if (loader) {
    return <Loader />;
  }

  return (
    <>
      {!isEditFlag ? (
        <>
          <div className="row flex-row top-section-depots-personal-tab justify-content-between align-items-center mt-2">
            <div className="col-md-3" style={{ position: "relative" }}>
              <input
                style={{ position: "relative", width: "100%" }}
                className="search-input-for-depot-personal-tab"
                type="text"
                placeholder="Search by name..."
                value={searchValue}
                onChange={handleSearchInputChange}
              />
              {searchValue !== "" ? (
                <Close
                  style={{ cursor: "pointer" }}
                  onClick={handleClearSearchText}
                  className="search-icon-depotpersonal-style"
                />
              ) : (
                <Search className="search-icon-depotpersonal-style" />
              )}
            </div>
            <div className="col-md-9 "></div>
          </div>
          <div
            className={`table-responsive ${projectManagerShowData?.length < 10
                ? ""
                : "main-div-admin-depotpersonal-tab"
              } d-flex flex-column mt-2`}
          >
            <table
              className="table admintab-depots-personal-table table-borderless"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th scope="col" style={{ minWidth: "180px" }}>
                    NAME
                  </th>
                  <th scope="col" style={{ minWidth: "180px" }}>
                    EMAIL
                  </th>
                  <th scope="col" style={{ minWidth: "120px" }}>
                    PHONE
                  </th>
                  <th scope="col" style={{ minWidth: "180px" }}>
                    CLIENT
                  </th>
                  <th scope="col" style={{ minWidth: "80px" }}>
                    PROJECTS
                  </th>
                  <th scope="col" style={{ minWidth: "80px" }}>
                    WEB-APP
                  </th>
                </tr>
              </thead>
              <tbody className="depotsperosnal-admin-tbl-body">
                {projectManagerShowData && projectManagerShowData.length > 0 ? (
                  _.orderBy(
                    projectManagerShowData,
                    (d) => d.firstName.toLowerCase(),
                    ["asc"]
                  ).map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr
                          onClick={() => handleRowClick(item, index)}
                          className={`${selectedRowIndex == index ? "row-border" : ""
                            }`}
                        >
                          <td>
                            <img
                              src={item?.profileUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                              onError={imgError}
                              alt="img"
                              width={25}
                              height={25}
                              className="me-1 depot-personel-list-img-style"
                            />
                            {item.firstName} {item.middleName} {item.lastName}{" "}
                          </td>
                          <td>{item.email}</td>
                          <td>{item.phoneNumber}</td>
                          <td>{showClientName(item?.projects)}</td>
                          <td>{item?.projects?.length || 0}</td>
                          <td
                            className={`${showGrantAppAccessFlag(item) == "Active"
                                ? "webapp-active-setColor"
                                : "webapp-inactive-setColor"
                              }`}
                          >
                            {showGrantAppAccessFlag(item)}
                          </td>
                        </tr>
                        {showViewRecordButton && selectedRowIndex == index && (
                          <tr className={`view-record-button`}>
                            <td>
                              <button
                                type="button"
                                className="text-uppercase view-button"
                                onClick={handleViewRecordButtonClick}
                              >
                                <i className="bi bi-eye-fill view-record-icon"></i>{" "}
                                View Record
                              </button>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      className="not-found-txt"
                      colSpan="8"
                      style={{ textAlign: "center" }}
                    >
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div
            style={{ height: 60 }}
            className="d-flex flex-row justify-content-end align-items-center"
          >
            <Button
              variant="outlined"
              className="btn-bootstrap-submit-style ms-3"
              startIcon={
                <img src={IconNewRecord} width={18} height={18} alt="new"></img>
              }
              onClick={handleOpen}
            >
              ADD PROJECT MANAGER
            </Button>
          </div>
        </>
      ) : (
        <ProjectManagerDetailView
          getAllClientsData={getAllClientsData}
          selectedData={selectedRow}
          isEditTextShown={isEditTextShown}
          setOpen={handleOpen}
          setIsEditTextShown={setIsEditTextShown}
          handleBackButtonClick={handleBackButtonClick}
          handleViewRecordButtonClick={handleViewRecordButtonClick}
        />
      )}

      <CommonModal togal={open} toggleHandler={handleOpen}>
        <AddProjectManagerForm
          setIsEditTextShown={setIsEditTextShown}
          isEditTextShown={isEditTextShown}
          setOpen={handleOpen}
          selectedData={selectedRow}
          getUpdateData={() => getProjectManager()}
          handleViewRecordButtonClick={handleViewRecordButtonClick}
        />
      </CommonModal>
    </>
  );
};
